import React from 'react';
import { l } from 'app/blocks/common/codes';

function StaticSearchNoOptionsPanel() {
    return (
        <div className="StaticSearch-noOptions">
            <p className="StaticSearch-noOptions-message">{l('SEARCH_CODES.STATIC.STATES.NO_RESULTS')}</p>
        </div>
    );
}

export default StaticSearchNoOptionsPanel;
